import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
import { buildSectionHeaderRegistry } from '@core/dynamic-components/utils/build-section-registry';
import { StringToIdPipe } from '@shared/ui/pipes/string-to-id/string-to-id.pipe';
import { booleanStringCheck } from '@shared/ui/utils/global-utils/boolean-string-check';

import { FamilyBlock } from '../jb-family-brand-block/types/jb-family-brand-block.type';

@Component({
  selector: 'jb-section-container',
  templateUrl: './section-container.component.html',
  styleUrls: ['./section-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JBSectionContainerComponent implements AfterViewInit {
  @Input('centerAligned') centerAligned;
  @Input('list') list;
  @Input('listOfSections') listOfSections;
  @Input('sectionHeaderData')
  set sectionHeaderData(data) {
    this.sectionHeader = data.section ? data : data.data;
    this.sectionHeader.removeSectionSpacing = booleanStringCheck(
      this.sectionHeader.removeSectionSpacing,
    );
    this.sanitizedTitle = this.sectionHeader?.title
      ? this.stringToIdPipe.transform(this.sectionHeader.title)
      : '';
  }

  sectionHeader: any;
  sanitizedTitle: string;

  constructor(
    private cdRef: ChangeDetectorRef,
    private stringToIdPipe: StringToIdPipe,
  ) {}

  registry: any;
  components: any;

  getSectionClass() {
    // Do not add any spacing when removeSectionSpacing is true
    if (this.sectionHeader.removeSectionSpacing) return '';

    // DOT-13066 - Use spacing from the h2 instead of adding mt to this section
    if (this.sectionHeader?.title) return 'mb6 mb8-ns';

    // DOT-12084
    if (this.sectionHeader?.section?.[0]?.name === 'calloutBlock') {
      return 'mb8 mb9-ns mt6 mt8-ns';
    }

    return 'mb6 mb8-ns mt6 mt8-ns';
  }

  getFamilyBlocks(familyBlocksData: any[]): FamilyBlock[] {
    return familyBlocksData.map(block => ({
      label: block.label || '',
      image: {
        src: block.image?.[0]?.src || '',
        alt: block.image?.[0]?.alt || '',
        title: block.image?.[0]?.title || '',
      },
      link: {
        title: block.link?.[0]?.title || '',
        href: block.link?.[0]?.href || '',
        target: block.link?.[0]?.newWindow === '_blank' ? '_blank' : '_self',
        isExternalLink: block.link?.[0]?.type === 'external',
      },
    }));
  }

  ngAfterViewInit() {
    this.registry = this.listOfSections
      ? buildSectionHeaderRegistry(this.listOfSections)
      : {};

    this.components =
      this.sectionHeader?.section && this.sectionHeader.section.length
        ? this.sectionHeader.section
        : [this.sectionHeader];

    this.cdRef.detectChanges();
  }
}
